module.exports = __webpack_public_path__ + "img/3-3.15765e0b.svg";